import React from "react";
import { Modal, Button } from "react-bootstrap";

const WelcomePage = ({ welShowHide, handleWelShowHide, userDetails }) => {
  return (
    <Modal show={welShowHide} size="lg">
      <Modal.Header closeButton onClick={handleWelShowHide}>
        <Modal.Title>Welcome to IPCS!</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-secondary pb-2">
        <div className="row">
          <h4 className="col-md-12 form-group pb-2">
            1st July 2025<br />
          </h4>
          <div className="col-md-12 form-group">
            Dear, {userDetails?.performername} {userDetails?.lastName}
          </div>
          <div className="col-md-12 form-group">
            As part of our business transformation effort, we are refining our business models and redesigning processes to enhance efficiency and strengthen collaboration with our customers, partners, and staff.
          </div>
          <div className="col-md-12 form-group">
            To this end, we are excited to announce that, beginning 1st July 2025, all our operations will be collaboratively managed through our new digital portal. This will include candidate and subcontractor onboarding, contract management, time log, invoicing, and payment processing.
          </div>
          <div className="col-md-12 form-group">
            We are confident that transition to digital-first approach will enhance our ability to work more efficiently and foster greater innovation.
          </div>
          <div className="col-md-12 form-group">
            We are therefore thrilled to welcome you to the portal!
          </div>
          <div className="col-md-12 form-group">Thank you for our continued partnership.</div>
          <div className="col-md-12 form-group">Sincerely</div>
          <div className="col-md-12 form-group">
            Kuldeep Dhar
            <br />
            CEO
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button size="sm" variant="outline-danger" onClick={handleWelShowHide}>
          <i class="fa fa-times mr-2" aria-hidden="true"></i>Close
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default WelcomePage;
